export function getSessionStorage(): Storage | null {
  if (typeof globalThis === 'undefined' || !('sessionStorage' in globalThis)) {
    return null;
  }

  return globalThis.sessionStorage;
}

export function getSessionStorageItem(key: string): string | null {
  return getSessionStorage()?.getItem(key) ?? null;
}

export function setSessionStorageItem(key: string, value: string): void {
  getSessionStorage()?.setItem(key, value);
}

export function removeSessionStorageItem(key: string): void {
  getSessionStorage()?.removeItem(key);
}
